// Constants
import { SHARED_EVENT_SET } from './constants';

// Types
import type { SharedEvent } from './types';

const initialState = null;

type State = ?SharedEvent;

type Action = {
    +type: string,
    +payload: any
};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case SHARED_EVENT_SET:
            return action.payload;
        default:
            return state;
    }
}
